// Shared by the full contact page and product inquiry modal.
export const PRODUCT_INQUIRY_FIELD_NAMES = {
  productName: "product_name",
  sourceProductSku: "Source Product SKU",
  estimatedOrderQuantity: "Estimated Order Quantity",
  packagingType: "Packaging Type",
  expectedLaunchDate: "Expected Launch Date",
  needs: "What Do You Need",
  productFocus: "Product Focus",
  inquirySummary: "Product Inquiry Details",
};

export const estimatedOrderQuantityOptions = [
  "1,000–2,999 retail units",
  "3,000–4,999 retail units",
  "5,000–9,999 retail units",
  "10,000+ retail units",
  "Not sure yet",
];

export const packagingTypeOptions = [
  "Paper Box",
  "Paper Envelope",
  "Pouch / Bag",
  "Bottle / Jar / Tub",
  "Bulk / Refill",
  "Need Recommendation",
  "Other",
];

export const needOptions = [
  "Samples",
  "Quote",
  "Custom Formula",
  "Packaging Support",
];

export const appendProductInquiryMetadata = (formData) => {
  const productName = String(formData.get(PRODUCT_INQUIRY_FIELD_NAMES.productName) || "").trim();
  formData.set(PRODUCT_INQUIRY_FIELD_NAMES.productName, productName);
  formData.set(PRODUCT_INQUIRY_FIELD_NAMES.productFocus, productName || "General product inquiry");

  const selectedNeeds = formData
    .getAll(PRODUCT_INQUIRY_FIELD_NAMES.needs)
    .filter(Boolean);

  if (selectedNeeds.length) {
    formData.set(PRODUCT_INQUIRY_FIELD_NAMES.needs, selectedNeeds.join(", "));
  }

  const summaryFields = [
    PRODUCT_INQUIRY_FIELD_NAMES.productFocus,
    PRODUCT_INQUIRY_FIELD_NAMES.sourceProductSku,
    PRODUCT_INQUIRY_FIELD_NAMES.estimatedOrderQuantity,
    PRODUCT_INQUIRY_FIELD_NAMES.packagingType,
    PRODUCT_INQUIRY_FIELD_NAMES.expectedLaunchDate,
    PRODUCT_INQUIRY_FIELD_NAMES.needs,
  ];

  const summary = summaryFields
    .map((fieldName) => {
      const value = formData.get(fieldName);
      return value ? `${fieldName}: ${value}` : null;
    })
    .filter(Boolean)
    .join("\n");

  if (summary) {
    formData.set(PRODUCT_INQUIRY_FIELD_NAMES.inquirySummary, summary);
    const message = String(formData.get("message") || "").trim();
    formData.set("message", `${message}\n\nProduct / Project Details\n${summary}`.trim());
  }

  return formData;
};
